/** Признак выводится по непустоте списка подкатегорий и потому неточен у смешанных клиентов */

import { MmSelectOption } from '../types/domain';

export function hasSubcategories(
  infoFlag: boolean | null,
  loadedSubcategories: MmSelectOption[] | null,
): boolean {
  if (infoFlag !== null) {
    return infoFlag;
  }

  return !!loadedSubcategories && loadedSubcategories.length > 0;
}

export function isSubcategoryRequiredForTpc(
  infoFlag: boolean | null,
  loadedSubcategories: MmSelectOption[] | null,
): boolean {
  return hasSubcategories(infoFlag, loadedSubcategories);
}
